import React, { useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { TimeFilter } from '../filters/TimeFilter';
import {
  Autocomplete,
  Divider,
  IconButton,
  Popper,
  Stack,
  Button,
} from '@mui/material';
import List from '@mui/material/List';
import { TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import api from '../../../services/api';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { CustomCellForPromotionActivity } from '../cell/CustomCellForPromotionActivity';

export const CustomFieldForPromotionActivities: FieldComponent<any, any> = ({
  onChange,
  isActive,
  value,
  hasTooltip,
  disabled,
  mui,
  column,
  allValue,
}) => {
  const [activities, setActivities] = React.useState<any>([]);
  const [tempActivities, setTempActivities] = useState<any>([]);
  const [selectOptions, setSelectOptions] = useState<[]>([]);
  const [addingEntity, setAddingEntity] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentEntity, setCurrentEntity] = React.useState<any>();

  const fetchSelectOptions = async (searchText: string) => {
    setLoading(true);

    const searchParams = new URLSearchParams({
      searchValue: searchText,
    });

    api.get(`/activities`, searchParams).then((result: any) => {
      result.data.unshift({ id: 0, name: '', isButton: true });
      setSelectOptions(result.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (value) {
      setActivities(value);
    }
  }, [value]);

  const CustomPopper = function (props: any) {
    return (
      <>
        <div>
          <Popper
            {...props}
            style={{ width: 'fit-content', maxWidth: '300px' }}
            placement="bottom-start"
            disableListWrap={true}
            sx={{
              '& .MuiPaper-root': {
                boxShadow: '0 4px 10px -1px rgb(17 20 24 / 20%)',
              },
            }}
          ></Popper>
        </div>
      </>
    );
  };

  const handleClickAddActivities = () => {
    const currentActivities = [...activities];
    tempActivities.map((newActivity: any) => {
      currentActivities.push(newActivity);
    });

    setActivities(currentActivities);
    setTempActivities([]);

    onChange(currentActivities);
  };

  const onChangeSelect = (event: any, value: any) => {
    let isReturn = false;
    const newValue = value.filter((item: any) => {
      if (item?.isButton) {
        isReturn = true;
      }
      return !item?.isButton;
    });
    setTempActivities(newValue);
    if (isReturn) {
      setAddingEntity(true);
    }
  };

  const onChangeActivityPrice = (id: number, values: any) => {
    const currentActivities = [...activities];
    const newActivities = currentActivities.map((activity: any) => {
      if (id === activity.id) {
        activity['prices'] = values;
      }
      return activity;
    });

    onChange(newActivities);
  };

  return (
    <>
      <Divider />

      <List component="div" aria-labelledby="Promotion activities">
        {activities.map((item: any) => {
          return (
            <>
              <CustomCellForPromotionActivity
                item={item}
                onChange={(id, values) => {
                  onChangeActivityPrice(id, values);
                }}
                deleteActivity={(id) => {
                  api
                    .delete(`/promotion-activity/${allValue?.id}/${id}`)
                    .then((result: any) => {
                      const newActivities = activities.filter((item: any) => {
                        return item?.id !== id;
                      });

                      setActivities(newActivities);
                    });
                }}
              />
            </>
          );
        })}
      </List>
      <Stack
        direction="row"
        spacing={1}
        justifyContent="flex-start"
        marginBottom={2}
        alignItems={'center'}
      >
        <div className="multiselect-field w-full">
          <Autocomplete
            sx={{
              '& .MuiOutlinedInput-root': {
                padding: '0',
              },
              '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
              '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                paddingTop: '0px',
                paddingBottom: '0px',
              },
              width: '100%',
              borderRadius: '50px',
              border: '1px solid #efefef',
              padding: '5px 0px',
            }}
            PopperComponent={CustomPopper}
            onInputChange={async (event, newInputValue) => {
              const options = await fetchSelectOptions(newInputValue);
            }}
            multiple
            //openOnFocus={true}
            fullWidth={true}
            //id={`combo-box-demo-${uuid}`}
            options={selectOptions}
            getOptionLabel={(option) => option?.name}
            isOptionEqualToValue={(option, value) => {
              return option.id === value.id;
            }}
            value={tempActivities}
            size="small"
            onChange={(event, newValue) => {
              onChangeSelect(event, newValue);
            }}
            autoHighlight={false}
            renderOption={(props: any, option: any) => {
              return (
                <Box
                  component="li"
                  sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  {option?.isButton && (
                    <Button
                      variant="contained"
                      startIcon={<AddIcon />}
                      size={'small'}
                      fullWidth
                    >
                      Add new
                    </Button>
                  )}
                  {option?.name}
                </Box>
              );
            }}
            renderInput={(paramsForInput) => {
              return (
                <TextField
                  {...paramsForInput}
                  size="small"
                  InputLabelProps={{
                    style: {
                      fontSize: 13,
                      paddingTop: 2,
                    },
                  }}
                  onFocus={async (event) => {
                    const options = await fetchSelectOptions('');
                  }}
                  //autoFocus={true}
                  InputProps={{
                    ...paramsForInput.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress
                            color="inherit"
                            size={20}
                            className={
                              'absolute right-[9px] text-[#b7b7b7] top-[1px]'
                            }
                          />
                        ) : null}
                        {paramsForInput.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              );
            }}
          />
        </div>
        <IconButton
          color={'primary'}
          onClick={() => {
            handleClickAddActivities();
          }}
        >
          <AddIcon />
        </IconButton>
      </Stack>
      <Divider />
    </>
  );
};

CustomFieldForPromotionActivities.includes = (query, value) => true;

CustomFieldForPromotionActivities.comparator = () => 0;

CustomFieldForPromotionActivities.FilterRenderer = TimeFilter;
